import { Plus } from "lucide-react";

const WA_NUMBER = "524424319100";
const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

const GUARDAS_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/ohe4gjr0_1.png",
    title: "Guarda telescópica en ensamble final",
    description:
      "Vista del taller con técnico revisando especificaciones del cliente sobre una guarda telescópica de acero inoxidable en proceso de ensamble. Control de calidad presente en cada etapa del trabajo.",
    specs: ["Acero inoxidable cal. 16", "Verificación dimensional por proyecto", "Control de calidad documentado"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/7s5rorm3_2.png",
    title: "Área de diseño y fabricación",
    description:
      "Vista panorámica del taller Guarda Flex: corte láser de alta precisión, mesas de ensamble, área de control de calidad y materia prima clasificada. Capacidad para fabricación a medida de cualquier modelo de CNC.",
    specs: ["Corte láser de alta precisión", "Capacidad de fabricación a medida", "Materia prima certificada"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/8btg2saj_3.jpg",
    title: "Detalle del pantógrafo soldado",
    description:
      "Close-up del mecanismo pantográfico tipo X con uniones soldadas reforzadas. La geometría se verifica con galgas y la soldadura cumple estándares industriales para garantizar millones de ciclos sin fatiga.",
    specs: ["Soldadura industrial certificada", "Geometría verificada con galgas", "Millones de ciclos sin fatiga"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/ky18bk48_4.png",
    title: "Guarda telescópica terminada en planta",
    description:
      "Producto final en la zona de diseño y fabricación de protecciones de maquinaria. Guarda telescópica completamente ensamblada, lista para verificación final y embarque al cliente.",
    specs: ["Embalaje protector para envío", "Etiquetado por proyecto del cliente", "Listo para instalación inmediata"],
  },
];

const FUELLES_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/2ljg5rw7_1.png",
    title: "Fuelle plisado de gran formato",
    description:
      "Cubierta protectora plisada con base metálica de fijación, lista para envolver guías lineales. Construcción reforzada con láminas rígidas en cada pliegue.",
    specs: ["PVC reforzado con poliéster", "Láminas rígidas en cada pliegue", "Base metálica con barrenos"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/zw4g3lur_2.png",
    title: "Detalle del plisado técnico",
    description:
      "Vista cercana del plisado vertical. La geometría triangular del pliegue maximiza la rigidez longitudinal y permite extensión/compresión repetida.",
    specs: ["Resistente a refrigerantes", "Estable a temperatura industrial", "Sellado entre láminas"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/zi93pqq6_3.png",
    title: "Fuelle de gran longitud extendido",
    description:
      "Configuración fabricada a medida para CNC de bancada extensa. Se entrega plegado y se instala directamente sobre los carriles del eje.",
    specs: ["Longitudes hasta 6 m por pieza", "Empalmes opcionales", "Diseño a medida"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/dw1bqcxm_4.jpg",
    title: "Producción y embalaje",
    description:
      "Lote de fuelles plisados listos para embarcar. Cada pieza se entrega embalada para evitar deformación y se etiqueta por proyecto.",
    specs: ["Embalaje protector reforzado", "Etiquetado por proyecto", "Logística nacional"],
  },
];

const LAMINILLAS_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/3ubmejmd_1.jpg",
    title: "Cubierta de fuelle con laminillas paralelas",
    description:
      "Sistema híbrido que combina la flexibilidad de un fuelle plisado con laminillas metálicas paralelas que protegen contra impactos directos de viruta y herramientas.",
    specs: ["Laminillas en aluminio anodizado", "Base rígida de fijación", "Protección dual: impacto + sello"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/3qbb8h3j_2.jpg",
    title: "Estructura con base de montaje",
    description:
      "Conjunto completo con bandeja de base, fuelle plisado interior y laminillas exteriores. Diseñado para CNC con alta proyección de chips a temperatura.",
    specs: ["Bandeja con barrenos para montaje", "Fuelle interior antifiltración", "Apertura/cierre suave"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/cq9a1tjd_3.jpg",
    title: "Vista del perfil de laminillas",
    description:
      "Detalle del apilamiento de las laminillas metálicas que actúan como barrera frente a viruta caliente, proyecciones y golpes accidentales.",
    specs: ["Espesor de laminilla controlado", "Bordes redondeados", "Compatible con refrigerantes"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/meyb7k2y_4.jpg",
    title: "Sistema completo con clips",
    description:
      "Vista posterior donde se aprecian los clips de fijación azules y el ensamble entre fuelle y laminillas. Listo para instalación en el carril del CNC.",
    specs: ["Clips de fijación reutilizables", "Fácil reemplazo de laminillas", "Diseño modular"],
  },
];

const CIRCULAR_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/k5kerzex_1.png",
    title: "Fuelle circular en abanico extendido",
    description:
      "Vista del fuelle circular con su estructura cónica completamente expandida. Los pliegues anulares mantienen rigidez radial sin perder flexibilidad axial, ideal para columnas verticales y ejes rotativos.",
    specs: ["Pliegues anulares uniformes", "Recuperación elástica total", "Hasta 12× extensión sobre comprimido"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/qyn3f1pk_2.png",
    title: "Configuración de doble diámetro",
    description:
      "Fuelle escalonado en dos secciones de distinto diámetro, diseñado para proteger transiciones entre componentes de diferente tamaño en husillos y vástagos verticales.",
    specs: ["Diámetros a medida del cliente", "Costuras reforzadas y selladas", "Unión hermética entre niveles"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/4oxkch5x_3.png",
    title: "Extremo cilíndrico con tapa rígida",
    description:
      "Configuración con tapa terminal termoformada que sella el extremo de la columna o husillo contra entrada de viruta, refrigerante o polvo metálico.",
    specs: ["Tapa rígida termoformada", "Sello continuo perimetral", "Salida lateral opcional"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/4gl5ulwh_4.jpeg",
    title: "Cuerpo cilíndrico anular estándar",
    description:
      "Fuelle circular de cuerpo continuo con pliegues regulares en PVC reforzado. Compatible con ejes rotativos y desplazamientos lineales en CNC verticales.",
    specs: ["PVC reforzado de alta durabilidad", "Estable a 80 °C continuos", "Fabricación a medida del cliente"],
  },
];

const MESA_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/gd2eldtt_5.png",
    title: "Mesa elevadora industrial con fuelle perimetral",
    description:
      "Cubierta plisada perimetral instalada en una mesa elevadora industrial. El fuelle sella completamente el espacio inferior, protegiendo el mecanismo hidráulico contra polvo, refrigerante y residuos metálicos.",
    specs: ["Sellado perimetral total", "Compatible con plataformas grandes", "Resistente a aceites hidráulicos"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/ym5i7bsh_6.jpeg",
    title: "Render técnico — configuración rectangular",
    description:
      "Representación 3D del fuelle rectangular plisado con base de aluminio. Muestra la geometría exacta del plisado vertical y la unión hermética con la placa superior móvil.",
    specs: ["Plisado vertical uniforme", "Base de aluminio con perfil rígido", "Tapa superior intercambiable"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/2zz6z6g2_7.jpg",
    title: "Fuelle de gran formato en planta",
    description:
      "Sistema de gran longitud fabricado para mesa elevadora industrial pesada, fotografiado en planta antes de su instalación. Estructura plisada modular preparada para cargas elevadas.",
    specs: ["Longitudes hasta 4 m por pieza", "Diseño modular ampliable", "Carga hasta 5 toneladas"],
  },
];

const ROLLUP_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/y29gb517_9.jpeg",
    title: "Roll Up Cover en ángulo con bastidor",
    description:
      "Cubierta enrollable industrial con perfil de aluminio y cubierta flexible negra texturizada. Se mantiene tensa por gravedad o resorte y se enrolla automáticamente al replegarse, ahorrando espacio en el CNC.",
    specs: ["Cubierta flexible reforzada", "Bastidor en aluminio extruido", "Mecanismo de retorno por resorte"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/68oyv3td_10.jpeg",
    title: "Sujeción manual y escala real",
    description:
      "Pieza terminada lista para instalación, sostenida con guante de protección. Permite apreciar la escala compacta del sistema y la rigidez del perfil inferior reforzado.",
    specs: ["Perfil inferior reforzado", "Manejo ergonómico para instalación", "Ajuste preciso a guía OEM"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/amlh9tr6_11.jpeg",
    title: "Vista cenital del Roll Up Cover",
    description:
      "Vista superior del bastidor con barrenos de montaje visibles y cubierta texturizada extendida. La cortina ofrece protección homogénea contra viruta y refrigerante sin perder flexibilidad.",
    specs: ["Bastidor de fijación reforzado", "Cubierta texturizada antideslizante", "Para CNC verticales y horizontales"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/n4s9y2cx_12.jpeg",
    title: "Carcasa enrolladora compacta",
    description:
      "Carcasa metálica que contiene el mecanismo de enrollado por resorte. Su diseño compacto facilita la integración en espacios reducidos del CNC sin interferir con otros componentes.",
    specs: ["Carcasa metálica robusta", "Pestañas con barrenos para montaje directo", "Mecanismo interno protegido"],
  },
];

const METALICAS_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/ibmmr1n1_13.jpeg",
    title: "Guarda metálica enrollada — vista completa",
    description:
      "Sistema flexible compuesto por laminillas de aluminio unidas por bordes de elastómero rojo. La estructura se enrolla sobre sí misma cuando el eje se repliega, ahorrando espacio sin perder rigidez ni protección.",
    specs: ["Laminillas de aluminio extruido", "Bordes elastoméricos sellantes", "Enrollado compacto sin deformación"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/y8scezuo_14.jpeg",
    title: "Panel extendido en operación",
    description:
      "Vista del panel metálico flexible totalmente extendido sobre la guía del CNC. El perfil ribbed mantiene rigidez longitudinal mientras permite curvatura transversal para adaptarse al recorrido del eje.",
    specs: ["Rigidez longitudinal alta", "Curvatura transversal controlada", "Cubierta resistente a viruta caliente"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/1utu1654_15.jpeg",
    title: "Vista en ángulo del perfil flexible",
    description:
      "Perspectiva lateral que muestra la curvatura natural del sistema cuando se monta sobre guías curvas o transiciones angulares. Las laminillas mantienen contacto continuo entre sí evitando filtraciones.",
    specs: ["Compatible con guías curvas", "Sello continuo entre laminillas", "Movimiento dinámico sin fricción"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/8barlv9d_16.jpeg",
    title: "Detalle del enrollado y bordes",
    description:
      "Detalle final del producto terminado mostrando el enrollado compacto y los bordes laterales con perfil rígido. Listo para instalación directa en centros de maquinado de alta velocidad.",
    specs: ["Perfil lateral rígido reforzado", "Acabado pulido en aluminio", "Instalación rápida en planta"],
  },
];

const PARED_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/8ymy2m3d_17.jpeg",
    title: "Panel modular frontal con núcleo central",
    description:
      "Vista frontal del sistema modular de pared con paneles ribbed laterales y un módulo central reforzado que aloja accesos de servicio. Estructura autoportante sobre base metálica para instalación directa en piso o pared.",
    specs: ["Paneles ribbed de aluminio", "Núcleo central reforzado", "Base autoportante atornillable"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/42okju8n_18.jpeg",
    title: "Estructura posterior con pantógrafos",
    description:
      "Vista posterior que revela los mecanismos pantográficos internos tipo X y los soportes laterales articulados. Esta configuración permite reposicionar los paneles para crear celdas modulares de protección a medida.",
    specs: ["Mecanismos pantográficos internos", "Soportes laterales articulados", "Reconfiguración a medida"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/bbwy27wz_19.jpeg",
    title: "Configuración modular adaptable",
    description:
      "Sistema modular de pared diseñado para integrarse a cualquier celda de maquinado. Los paneles se ensamblan entre sí mediante uniones atornilladas, permitiendo reconfigurar el perímetro de protección según las dimensiones del CNC o la línea automatizada.",
    specs: ["Paneles ensamblables entre sí", "Reconfigurable según el layout", "Ventana de servicio y paso de cables integrados"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/pvz6ei5b_20.jpeg",
    title: "Panel telescópico con perforación de servicio",
    description:
      "Configuración telescópica vertical con perforación circular para paso de mangueras, válvulas o cables. La estructura ribbed perimetral con remaches sellados garantiza rigidez total bajo cargas dinámicas.",
    specs: ["Estructura telescópica vertical", "Remachado sellado perimetral", "Perforación de servicio reforzada"],
  },
];

const PRIMARY = [
  {
    key: "guardas",
    num: "01",
    title: "Guardas Telescópicas",
    tag: "CNC PROTECTION",
    desc: "Protección extensible para guías lineales y ejes. Acero inoxidable de alta resistencia con pantógrafo de precisión.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/px4uzuxf_01%20%20%20%20CNC%20PROTECTION.png",
    photos: GUARDAS_PHOTOS,
  },
  {
    key: "fuelles",
    num: "02",
    title: "Fuelles Industriales",
    tag: "FLEXIBLE COVERS",
    desc: "Cubiertas plisadas de alta resistencia para guías, columnas y ejes de centros de maquinado.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/eicut6fw_02%20%20%20%20FLEXIBLE%20COVERS.png",
    photos: FUELLES_PHOTOS,
  },
  {
    key: "laminillas",
    num: "03",
    title: "Guardas de Fuelles con Laminillas",
    tag: "HYBRID SHIELD",
    desc: "Sistema híbrido que combina fuelle plisado interior con laminillas metálicas exteriores para protección reforzada.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/trfbvjd1_03%20%20%20%20HYBRID%20SHIELD.png",
    photos: LAMINILLAS_PHOTOS,
  },
  {
    key: "circular",
    num: "04",
    title: "Guardas de Fuelle Circular",
    tag: "CIRCULAR BELLOW",
    desc: "Fuelles circulares para ejes rotativos, columnas y husillos verticales. Construcción anular en PVC reforzado o caucho técnico.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/g9yi7uh5_04%20%20%20%20CIRCULAR%20BELLOW.jpeg",
    photos: CIRCULAR_PHOTOS,
  },
  {
    key: "mesa",
    num: "05",
    title: "Fuelles para Mesas Elevadoras",
    tag: "LIFT TABLE",
    desc: "Cubiertas plisadas de gran formato para mesas elevadoras industriales. Sellado total contra polvo y refrigerante.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/om26ly0q_05%20%20%20%20LIFT%20TABLE.jpg",
    photos: MESA_PHOTOS,
  },
  {
    key: "rollup",
    num: "06",
    title: "Roll Up Cover (Cortinas Enrollables)",
    tag: "ROLL-UP",
    desc: "Cortinas enrollables motorizadas o manuales para protección horizontal y vertical de ejes largos de CNC.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/zgeynf5i_06%20%20%20%20ROLL-UP.png",
    photos: ROLLUP_PHOTOS,
  },
  {
    key: "metalicas",
    num: "07",
    title: "Guardas Metálicas Flexibles",
    tag: "FLEX METAL",
    desc: "Sistemas articulados en chapa de aluminio con uniones flexibles para protección dinámica de máquinas de alta velocidad.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/cq1yc09r_07%20%20%20%20FLEX%20METAL.png",
    photos: METALICAS_PHOTOS,
  },
  {
    key: "pared",
    num: "08",
    title: "Guardas de Pared Sistema Modular",
    tag: "MODULAR WALL",
    desc: "Paneles modulares de protección perimetral para celdas de maquinado y centros automatizados. Diseño a medida del cliente.",
    img: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/rt6v0xf4_08%20%20%20%20MODULAR%20WALL.jpeg",
    photos: PARED_PHOTOS,
  },
];

function PrimaryTile({ item }) {
  return (
    <article
      data-testid={`gallery-item-${item.key}`}
      className="group relative bg-white border border-slate-200 shadow-[0_2px_12px_-6px_rgba(10,27,53,0.12)] hover:shadow-[0_16px_36px_-16px_rgba(10,27,53,0.25)] transition-shadow duration-300 p-6 pt-7 flex flex-col"
      style={{ borderRadius: "6px" }}
    >
      {/* Escuadras técnicas */}
      <span className="absolute top-3 left-3 w-4 h-4 border-t-2 border-l-2 border-slate-900 pointer-events-none" />
      <span className="absolute top-3 right-3 w-4 h-4 border-t-2 border-r-2 border-slate-900 pointer-events-none" />
      <span className="absolute bottom-3 left-3 w-4 h-4 border-b-2 border-l-2 border-slate-900 pointer-events-none" />
      <span className="absolute bottom-3 right-3 w-4 h-4 border-b-2 border-r-2 border-slate-900 pointer-events-none" />

      {/* Badge monoespaciado */}
      <span
        data-testid={`gallery-badge-${item.key}`}
        className="self-start font-mono-accent text-[10px] uppercase tracking-[0.2em] text-slate-900 bg-slate-200 px-3 py-1.5 rounded-full"
      >
        {item.num}&nbsp;&nbsp;|&nbsp;&nbsp;{item.tag}
      </span>

      {/* Área de foto limpia y centrada */}
      <div
        className="my-6 h-44 lg:h-48 flex items-center justify-center bg-[#F8FAFC] border border-slate-100 overflow-hidden"
        style={{ borderRadius: "4px" }}
      >
        <img
          src={item.img}
          alt={item.title}
          loading="lazy"
          className="max-h-full max-w-full object-contain p-3 transition-transform duration-500 group-hover:scale-[1.04]"
        />
      </div>

      <h3 className="font-display font-black text-[#0F172A] text-xl lg:text-2xl tracking-tight leading-tight mb-2">
        {item.title}
      </h3>
      <p className="text-slate-800 text-sm leading-relaxed mb-6 flex-1 opacity-100">
        {item.desc}
      </p>

      {/* Botón principal de cotización */}
      <div>
        <a
          href={waLink(`Hola, me interesa cotizar: ${item.title}`)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`gallery-item-cta-${item.key}`}
          className="flex items-stretch border border-[#94A3B8] bg-white hover:border-slate-900 hover:bg-slate-50 transition-colors"
          style={{ borderRadius: "4px", borderWidth: "1.5px" }}
        >
          <span
            className="w-11 flex items-center justify-center border-r border-[#94A3B8] text-slate-900 shrink-0"
            style={{ borderRightWidth: "1.5px" }}
          >
            <Plus size={15} strokeWidth={2.5} />
          </span>
          <span className="flex-1 text-center text-[11px] font-bold uppercase tracking-[0.15em] text-[#0F172A] py-3">
            Cotizar este sistema
          </span>
        </a>
      </div>
    </article>
  );
}

export default function Gallery() {
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="gf-section bg-[#F1F5F9]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#00B4D8]" />
              <span className="gf-overline">Portafolio · 8 sistemas</span>
            </div>
            <h2 className="font-display font-black text-[#0A1B35] text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Soluciones que protegen
              <span className="text-[#00B4D8]"> tu centro de maquinado.</span>
            </h2>
          </div>
          <button
            onClick={() => goTo("contacto")}
            data-testid="gallery-cta"
            className="gf-btn-secondary self-start lg:self-auto"
          >
            Solicitar Proyecto
          </button>
        </div>

        {/* Fichas técnicas de catálogo — 8 sistemas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {PRIMARY.map((item) => (
            <PrimaryTile key={item.key} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
